export default __webpack_public_path__ + "static/tooltip-truncation-dont-dark-fd503f7691c32fc51b34756f534cb1449aaf4415be0d886b6825f3945aabe46c.png";